import Udesk from 'Udesk';

export const InitialValues = {
    conditionList: [
        {
            idCode: `R1`,
            conditionType: 1,
            applyRole: 'all',
            applyConditionHitType: 1,
            applyConditionScope: undefined,
            applyTimeType: 1,
            applyTimeId: undefined,
            operator: 'all',
            operatorLogic: '1',
            operatorList: [
                {
                    applyConditionHitType: 1,
                    applyOperatorScope: {
                        key: 'all',
                        id: 1,
                    },
                    operator: 'all',
                    applyRole: 'all',
                    param: {
                        version: 1,
                    },
                },
            ],
        },
    ],
    ruleList: [{ formula: '', judgeStrategy: Udesk.enums.operatorRuleTypes.all.id }],
};
